import { StoreActionApi } from 'react-sweet-state';

import { getProgressForCourses } from 'src/services/http/progress';
import { ProgressState } from 'src/store/progress/progressStore';
import { User } from 'src/types';
import { ContentfulLearningPathWithNavigation } from 'src/graphql/queries/GetLearningPathWithNavigation';
import { ContentfulLearningPath } from 'src/graphql/queries/GetLearningPath';

export const fetchProgressForCourses =
  (
    learningPath: ContentfulLearningPathWithNavigation | ContentfulLearningPath | undefined,
    user: User | null | undefined,
  ) =>
    async ({ getState, setState }: StoreActionApi<ProgressState>): Promise<void> => {
      if (!user || !learningPath) {
        return;
      }

      const { progressForCourses } = getState();
      const courseIds = learningPath.coursesCollection.items.map((course) => course.sys.id);
      const currentCourseIds = (progressForCourses?.courses || []).map((c) => c.courseId).sort();
      const newCourseIds = courseIds.slice().sort();

      const isSameCourses =
      currentCourseIds.length === newCourseIds.length && currentCourseIds.every((id, idx) => id === newCourseIds[idx]);

      if (!isSameCourses) {
        setState({
          progressForCourses: undefined,
          isLoadingProgressForCourses: true,
        });
        const progress = await getProgressForCourses(courseIds);

        setState({
          progressForCourses: progress,
          isLoadingProgressForCourses: false,
        });

        return;
      }

      const hasNoProgress = !progressForCourses?.courses?.length;
      const hasAllCourses =
      !hasNoProgress && courseIds.every((id) => progressForCourses.courses.some((course) => course.courseId === id));

      if (hasAllCourses) {
        return;
      }

      setState({ isLoadingProgressForCourses: true });
      const progress = await getProgressForCourses(courseIds);

      setState({
        progressForCourses: progress,
        isLoadingProgressForCourses: false,
      });
    };
